/*eslint-disable */

import axios from 'axios';
import root from '@/_helpers/roots';
import toast from '@/services/toast';

let sampleFileForModel = root.sampleFileForModelApiUrl.link;
var $ = window.jQuery = require('jquery');
export default {
  name: 'batch-patients-data-use',
  components: {},
  props: ['selectedModelInfo'],
  data() {
    return {
      useModelFirstStep: false,
      useModelSecondStep: true,
      submitted: false,
      patient_name:'',
      file:null,
      uploadAttachmentName:'',
      modelTrainedLoader:false,
      modelOutputData:null,
      predictedBatchFilePopupState:false,
      downloadFileIsSubmitted:false,
      predicationErrorPopupState:false,
      predicationErrorText:'',
      prdctnFileDownloadFblurb:false
    }
  },
  computed: {

  },
  mounted() {
  },
  methods: {
    openPrdctnFileblurbMethod(){
      this.prdctnFileDownloadFblurb = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    closedPrdctnFileblurbMethod(){
      this.prdctnFileDownloadFblurb = false;
      document.body.classList.remove('body_right_scroll_remove');
    },
    sampleFileDonwloadMethod(){
      this.downloadFileIsSubmitted = true;
      axios.get(sampleFileForModel + '?model_id=' + this.selectedModelInfo.id).then((res) => {
        this.downloadSampleFileMethod(res.data.data.input_data);
        this.downloadFileIsSubmitted = false;
        this.closedPrdctnFileblurbMethod();
      })
    },
    predictedBatchFilePopupOpenMethod(){
      this.predictedBatchFilePopupState = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    predictedBatchFilePopupCloseMethod(){
      this.predictedBatchFilePopupState = false;
      document.body.classList.remove('body_right_scroll_remove');
      this.backToFirstStepBatch();
    },
    clearedUploadedFileMethod(){
        this.$refs.file.value = null;
        this.file = null;
        this.uploadAttachmentName = '';
        this.$validator.reset();
    },
    downloadSampleFileMethod(dataurl) {
      fetch(dataurl.file)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = dataurl.file_name;
        link.click();
      }).catch(console.error);
    },
    downloadPredictedFileMethod(dataurl) {
      fetch(dataurl.file)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = dataurl.file_name;
        link.click();
        this.predictedBatchFilePopupCloseMethod();
      }).catch(console.error);
    },
    handleAttachmentUpload(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.file.name;
      }else {
        this.uploadAttachmentName = '';
      }
    },
    stepFirstUseFormMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.useModelFirstStep = false;
          setTimeout(()=>{
            this.useModelSecondStep = true;
          },1)
          this.submitted = false;
          return;
        }
      })
    },
    stepSecondUseFormMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.modelTrainedLoader = true;
          var formData = new FormData();
          formData.append('file', this.file);
          this.$store.dispatch('modelPredictForBatchDataAction', {data:{id:this.selectedModelInfo.id, data:formData}})
            .then((res) => {  
              this.modelOutputData = res.data.data;
              this.predictedBatchFilePopupOpenMethod();
              toast.success("Request processed successfully");
              this.modelTrainedLoader = false;
              this.submitted =  false;
            }).catch((err) => {
              this.modelTrainedLoader = false;
              this.submitted =  false;
              if(err.data.code == '4001'){
                this.predicationErrorPopupState = true;
                this.predicationErrorText = err.data.data.data;
                document.body.classList.add('body_right_scroll_remove');
              }else{
                toast.error(err.data.user_msg || err.data.msg);
              }
            })
          return;
        }
      })
    },
    backToFirstStepBatch(){
      // this.useModelSecondStep = false
      setTimeout(()=>{
        // this.useModelFirstStep = true
        this.patient_name = '';
        this.clearedUploadedFileMethod();
      }, 1)
    },
    closePredicationErrorPopupMethod(){
      this.patient_name = '';
      this.clearedUploadedFileMethod();
      this.predicationErrorPopupState = false;
      this.predicationErrorText = '';
      document.body.classList.remove('body_right_scroll_remove');
    }
  }
}